import React from 'react';
import PropTypes from 'prop-types';
import { ShortCarouselCard, LazyLoadAspectRatioCardImage, AspectRatioCardTitle, AspectRatioCardText } from '../Carousel/CarouselCard';

const CNAME = 'Trending';

const TrendingCard = ({
  onClick,
  slpUrl,
  serpUrl,
  imageUrl,
  location,
  name,
  cardAspectRatio
}) => (
  <ShortCarouselCard
    clickUrl={slpUrl || serpUrl}
    className={`${CNAME}__link`}
    onClick={onClick}
  >
    <LazyLoadAspectRatioCardImage
      data-slot={'figure'}
      aspectRatio={cardAspectRatio}
      imageUri={imageUrl.replace('${templateId}', 'hw6')}
    />
    <AspectRatioCardTitle data-slot={'caption'} title={name} />
    <AspectRatioCardText data-slot={'content'} text={location} />
  </ShortCarouselCard>
);

TrendingCard.propTypes = {
  onClick: PropTypes.func,
  slpUrl: PropTypes.string,
  serpUrl: PropTypes.string,
  imageUrl: PropTypes.string,
  location: PropTypes.string,
  name: PropTypes.string
};

TrendingCard.defaultProps = {
  cardAspectRatio: '4x3'
};

export default TrendingCard;
